<template>
  <!--Welcome Section Content Start-->
  <div>
    <section class="tj-welcome" v-if="whoWeAre">
      <jumbotron :h1="'About Us'" v-if="this.$route.fullPath!='/'"/>
      <div class="container">
        <div class="row">
          <!--Welcome Section Start-->
          <div class="col-md-6 col-sm-7">
            <div class="about-info">
              <div class="tj-heading-style">
                <h3>Who We Are</h3>
              </div>
              <p>{{whoWeAre.description}}</p>
              <!-- <a href="fleet-grid.html">
              See all Vehicles
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </a>-->
              <ul class="facts-list">
                <li>
                  <strong class="fact-count">{{whoWeAre.HappyCustomer}}</strong>
                  <i class="fa fa-percent"></i>
                  <span>Customers Satisfied</span>
                </li>
                <li>
                  <strong class="fact-count">{{whoWeAre.LuxuryCars}}</strong>
                  <i class="fas fa-plus"></i>
                  <span>Great Cars</span>
                </li>
                <li>
                  <strong class="fact-count">{{whoWeAre.KilometersDriven}}</strong>
                  <i class="fas fa-arrow-up"></i>
                  <span>Miles Driven</span>
                </li>
              </ul>
            </div>
          </div>
          <!--Welcome Section End-->
          <!--Welcome Section Image Box Start-->
          <div class="col-md-6 col-sm-5">
            <div class="welcome-banner">
              <img :src="whoWeAre.imageUrl" alt />
            </div>
          </div>
          <!--Welcome Section Image Box End-->
        </div>
      </div>
    </section>
  </div>

  <!--Welcome Section Content End-->
</template>
<script>
import firebase from "firebase";
import  jumbotron  from "./jumbotron";
export default {
  props: {
    data: Object
  },
  components:{jumbotron},
  data() {
    return {
      whoWeAre: null,
    };
  },
  mounted() {
    
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    if (this.data) {
      this.whoWeAre = this.data;
    } else {
      let that = this;
      var ref = firebase.database().ref("/WhoWeAre");
      ref.on(
        "value",
        function(snapshot) {
          that.whoWeAre = snapshot.val();
          // console.log(snapshot.val());
        },
        function(error) {
          console.log("Error: " + error.code);
        }
      );
    }
  }
};
</script>
<style scoped>

</style>